/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FuQiangXinDemo.vue?vue&type=template&id=19cdf2e6&scoped=true&"
import script from "./FuQiangXinDemo.vue?vue&type=script&lang=js&"
export * from "./FuQiangXinDemo.vue?vue&type=script&lang=js&"
import style0 from "./FuQiangXinDemo.vue?vue&type=style&index=0&id=19cdf2e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdf2e6",
  null
  
)

export default component.exports